module.exports = __webpack_public_path__ + "2384bd5c7a28e1592b965bbda3350eda.jpg";